module.exports = "/_next/static/images/icon_fb-b10e7d7eee4939793fd44df5f4647fb8.svg";